import lozad from 'lozad';
import Swiper from 'swiper';

const el = document.querySelectorAll('.initVideo');
const observer = lozad(el);
observer.observe();

$(function () {
    initVideoCover();
    handleGalleryVideoPlayback();
    handleMobileSliderVideoPlayback();
    handleMuteToggle();
    initViewportPlayback();

    $(window).on('resize', function () {
        initVideoCover();
    });

    setTimeout(() => {
        const event = new Event('scroll');
        window.dispatchEvent(event);
    }, 100);
});

// Single IntersectionObserver that governs playback for every `.initVideo`.
// Plays videos when at least ~25% of them is in the viewport and pauses
// them as soon as they leave, so we never keep streaming off-screen videos.
// Mobile swiper slides are only paused here; the swiper handler owns which
// slide should be actively playing.
function initViewportPlayback() {
    if (!('IntersectionObserver' in window)) {
        return;
    }

    const videos = document.querySelectorAll('.initVideo');
    if (!videos.length) {
        return;
    }

    const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const video = entry.target;

            if (entry.isIntersecting) {
                if (video.dataset.userPaused === 'true') {
                    return;
                }
                // Swiper-managed mobile gallery: only ever pause, never auto-play.
                if (video.closest('.swiper--videos--mobile')) {
                    return;
                }
                if (video.paused) {
                    // Autoplay policies require muted playback for unattended starts.
                    video.muted = true;
                    const playPromise = video.play();
                    if (playPromise && typeof playPromise.catch === 'function') {
                        playPromise.catch(error => console.warn('Autoplay failed:', error));
                    }
                }
            } else if (!video.paused) {
                video.pause();
            }
        });
    }, { threshold: 0.25 });

    videos.forEach(video => io.observe(video));
}

function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function pauseAllMobileGalleryVideos() {
    const galleryVideos = document.querySelectorAll('.swiper--videos--mobile .initVideo');
    galleryVideos.forEach(video => {
        video.pause();
        $(video).closest('.video--overlay').removeClass('disabled');
        $(video).closest('.browser--card--inner').find('.mute-toggle').addClass('hidden');
    });
}

function initVideoCover() {
    $('.initVideo').each(function () {
        var video = $(this);
        var size = 'large';
        var source = "<source class='video--source' src='" + $(video).data(size) + "' type='video/mp4'>";
        if ($(this).hasClass('initDesktop') && window.matchMedia('(max-width:1023px), (orientation: portrait)').matches) {
            video.children().remove();
        } else {
            if (video.children().length == 0) {
                video.append(source);
            }
        }
    });
}

function handleGalleryVideoPlayback() {
    const galleryVideos = document.querySelectorAll('.block--video_gallery .initVideo');

    $('.block--video_gallery .video--overlay, .block--video_gallery .initVideo').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();

        const ctrlVideo = $(this).hasClass('initVideo') ? this : $(this).find('.initVideo')[0];

        if (ctrlVideo.paused) {
            pauseAllGalleryVideos();
            delete ctrlVideo.dataset.userPaused;
            $(ctrlVideo).closest('.video--overlay').addClass('disabled');
            ctrlVideo.muted = false;
            ctrlVideo.play().catch(error => {
                console.warn('Playback failed:', error);
            });
            $(ctrlVideo).closest('.browser--card--inner').find('.mute-toggle').removeClass('hidden');
        } else {
            ctrlVideo.pause();
            ctrlVideo.dataset.userPaused = 'true';
            $(ctrlVideo).closest('.video--overlay').removeClass('disabled');
            $(ctrlVideo).closest('.browser--card--inner').find('.mute-toggle').addClass('hidden');
        }
    });

    galleryVideos.forEach(video => {
        video.addEventListener('fullscreenchange', handleFullscreenChange);
        video.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        video.addEventListener('mozfullscreenchange', handleFullscreenChange);
        video.addEventListener('msfullscreenchange', handleFullscreenChange);

        video.addEventListener('ended', function() {
            $(video).closest('.browser--card--inner').find('.mute-toggle').addClass('hidden');
        });
    });

    function handleFullscreenChange() {
        if (!document.fullscreenElement && !document.webkitFullscreenElement && !document.mozFullScreenElement && !document.msFullscreenElement) {
            pauseAllGalleryVideos();
        }
    }

    function pauseAllGalleryVideos() {
        galleryVideos.forEach(video => {
            video.pause();
            $(video).closest('.video--overlay').removeClass('disabled');
            $(video).closest('.browser--card--inner').find('.mute-toggle').addClass('hidden');
        });
    }
}

function handleMobileSliderVideoPlayback() {
    const swiper = new Swiper('.swiper--videos--mobile', {
        slidesPerView: 1.2,
        spaceBetween: 10,
        centeredSlides: true,
        breakpoints: {
            768: {
                slidesPerView: 2.2,
                centeredSlides: false
            }
        },
        on: {
            slideChangeTransitionEnd: function () {
                pauseAllMobileGalleryVideos();
                const activeSlide = document.querySelector('.swiper-slide-active .initVideo');
                if (activeSlide) {
                    $(activeSlide).closest('.video--overlay').addClass('disabled');
                    activeSlide.play().catch(error => console.warn('Autoplay failed:', error));
                }
            }
        }
    });
}

function handleMuteToggle() {
    $(document).on('click', '.mute-toggle', function(event) {
        event.stopPropagation();
        const video = $(this).siblings('.video--overlay').find('.initVideo')[0];
        video.muted = !video.muted;

        $(this).find('.icon-volume').toggleClass('hidden', video.muted);
        $(this).find('.icon-mute').toggleClass('hidden', !video.muted);
    });
}

$(document).ready(function() {
    $('.block--video .video--overlay').click(function() {
        $(this).addClass('disabled');
        const ctrlVideo = $(this).find('.initVideo')[0];
        delete ctrlVideo.dataset.userPaused;
        ctrlVideo.play();
        $(ctrlVideo).closest('.browser--card--inner').find('.mute-toggle').removeClass('hidden');
    });
});
